import React, { Component } from 'react';
import 'gsap'; // greensock tween library required by winwheel
import Winwheel from 'winwheeljs';
import { FONT_FAMILY_TITLE_LIST } from 'utils/constants';
import { formatNumber } from 'utils/formatting';
import withWheelSounds from './sound';
import wedgeBlue from './assets/Wheel-Blue.png';
import wedgeGreen from './assets/Wheel-Green.png';
import wedgeOrange from './assets/Wheel-Orange.png';
import wedgeRed from './assets/Wheel-Red.png';
import wheelPointer from './assets/Pointer.png';
import './WScoreWheel.css';

class WScoreWheel extends Component {
  constructor(props) {
    super(props);

    this.doSpin = this.doSpin.bind(this);

    if (this.props.registerSpinCallback) {
      this.props.registerSpinCallback(this.doSpin);
    }

    this.handleSpinClicked = this.handleSpinClicked.bind(this);

    this.playSegmentChange = this.playSegmentChange.bind(this);
    this.spinupFinished = this.spinupFinished.bind(this);
    this.spindownFinished = this.spindownFinished.bind(this);
    this.drawOverlay = this.drawOverlay.bind(this);

    this.state = {
      spinState: 'STARTUP',
      imagesLoaded: 0
    };

    this.WheelDiameter = 1000;
    this.PointerWidth = 144;
    this.FrameWidth = 55;
    this.PointerOffset = 55;
    this.CenterDiameter = 300;
    this.CenterPlacement = (this.WheelDiameter - this.CenterDiameter) / 2;
    this.CanvasWidth = this.WheelDiameter;
    this.CanvasHeight = this.WheelDiameter + this.PointerOffset;
    this.skippedSpinStartSound = false;

    this.canvas = (
      <canvas
        id="wscoreWheelCanvas"
        className="wscoreWheelCanvas"
        width={this.CanvasWidth}
        height={this.CanvasHeight}
      />
    );

    // pre-cache canvas drawn images behind loading state
    this.createImages();
    this.loadImages();
  }

  doSpin() {
    this.props.playSpinStart();
    this.handleSpinClicked();
  }

  setWedges(wedgeData, multiplier) {
    const images = [wedgeBlue, wedgeOrange, wedgeGreen, wedgeRed];
    let idx = 0;

    this.WheelWedges = wedgeData.map(elem => {
      return {
        image: images[idx++ % 4],
        textFontFamily: FONT_FAMILY_TITLE_LIST,
        text: formatNumber(parseInt(elem.amount, 10)), // * multiplier),  don't use multiplier as we're putting it in "total won" only
        textFontSize: 0.05 * this.WheelDiameter,
        textFillStyle: '#FFFFFF',
        textLineWidth: 0.003 * this.WheelDiameter,
        textFontWeight: 500,
        textStrokeStyle: '#000000',
        textAlignment: 'outer',
        textMargin: 0.5 * this.PointerOffset,
        textDirection: 'reversed',
        imageDirection: 'W'
      };
    });
  }

  createImages() {
    this.images = new Map();
    this.createWheelDecor();
    this.createWheelWedges();
  }

  createImage(image) {
    this.images.set(image, new Image());
  }

  createWheelDecor() {
    this.createImage(wheelPointer);
  }

  createWheelWedges() {
    this.createImage(wedgeBlue);
    this.createImage(wedgeOrange);
    this.createImage(wedgeGreen);
    this.createImage(wedgeRed);
  }

  loadImages() {
    this.imagesLoaded = [];
    this.loadWheelDecor();
    this.loadWheelWedges();
  }

  loadImage(image) {
    this.images.get(image).onload = () => {
      this.imagesLoaded.push(this.images.get(image));
      this.setState({ imagesLoaded: this.state.imagesLoaded + 1 });
    };
    this.images.get(image).src = image;
  }

  loadWheelDecor() {
    this.loadImage(wheelPointer);
  }

  loadWheelWedges() {
    this.loadImage(wedgeBlue);
    this.loadImage(wedgeOrange);
    this.loadImage(wedgeGreen);
    this.loadImage(wedgeRed);
  }

  drawOverlay() {
    var tcanvas = document.getElementById('wscoreWheelCanvas');
    var ctx = tcanvas ? tcanvas.getContext('2d') : null;
    if (ctx) {
      ctx.save();

      const pointerImage = this.images.get(wheelPointer);
      const posX = this.CanvasWidth / 1.8; // moves on wheel left + right
      const posY = this.CanvasHeight / 1.95; // moves on the wheel up + down

      ctx.translate(posX, posY);
      ctx.rotate(Math.PI / 2);
      ctx.drawImage(
        pointerImage,
        -this.CanvasWidth / 2 - this.PointerOffset / 2,
        -this.PointerWidth / 2
      );
      ctx.restore();
    }
  }

  playSegmentChange() {
    if (this.skippedSpinStartSound) {
      this.props.playSegmentChange();
    } else {
      this.skippedSpinStartSound = true;
    }
  }

  isLoading() {
    return (
      this.images.size !== this.imagesLoaded.length ||
      (this.props.wedgeData && this.props.wedgeData.loading)
    );
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (
      this.props.wedgeData &&
      !this.props.wedgeData.loading &&
      !this.props.wedgeData.error &&
      !this.isLoading() &&
      this.state.spinState === 'STARTUP'
    ) {
      this.setWedges(this.props.wedgeData, this.props.multiplier);
      this.setState({ spinState: 'IDLE' });
      this.props.loadingCompleteCallback &&
        this.props.loadingCompleteCallback();
    } else if (
      this.state.spinState === 'IDLE' &&
      prevProps.multiplier !== this.props.multiplier
    ) {
      this.setWedges(this.props.wedgeData, this.props.multiplier);
      this.stateIdle();
    }

    // reset to idle trigged by toggling stop index to null after having received a stop index
    if (prevProps.stopIndex != null && this.props.stopIndex == null) {
      this.setState({ spinState: 'IDLE' });
    }

    if (prevState.spinState !== this.state.spinState) {
      switch (this.state.spinState) {
        case 'IDLE':
          this.stateIdle();
          break;
        case 'SPINUP':
          this.stateSpinup();
          break;
        case 'SPINNING':
          this.stateSpinning();
          break;
        case 'STOPPING':
          this.stateStopping();
          break;
        case 'RESULTS':
          this.stateResults();
          break;
        default:
          // do some kind of error
          break;
      }

      if (this.props.stateChangeHandler)
        this.props.stateChangeHandler(
          prevState.spinState,
          this.state.spinState
        );
    }

    if (prevProps.stopIndex == null && this.props.stopIndex != null)
      this.spinResultReceived();
  }

  componentWillUnmount() {
    if (this.wheel) {
      // use pauseAnimation.  calling stopAnimation unwantedly triggers the animation finished callback
      this.wheel.pauseAnimation();
      this.wheel = null;
    }
  }

  stateIdle() {
    this.wheel = new Winwheel({
      canvasId: 'wscoreWheelCanvas',
      numSegments: this.WheelWedges.length,
      outerRadius: this.WheelDiameter / 2 - this.FrameWidth,
      centerX: this.WheelDiameter / 2,
      centerY: this.WheelDiameter / 2 + this.PointerOffset,
      segments: this.WheelWedges,
      rotationAngle: 11,
      drawMode: 'segmentImage',
      drawText: true,
      lineWidth: 3,
      animation: {
        type: 'spinOngoing',
        duration: 1.5,
        spins: 0.5,
        easing: 'Back.easeIn',
        direction: 'anti-clockwise',
        repeat: 0,
        yoyo: false,
        callbackAfter: this.drawOverlay,
        callbackFinished: this.spinupFinished,
        callbackSound: this.playSegmentChange
      }
    });
    // small timeout to draw after above wheel (callback after doesn't trigger until after start animation is called)
    setTimeout(this.drawOverlay, 200);

    this.skippedSpinStartSound = false;
  }

  stateSpinup() {
    // spin wheel, callback to parent to tell them of spin
    this.wheel.startAnimation();
  }

  stateSpinning() {
    this.wheel = new Winwheel({
      canvasId: 'wscoreWheelCanvas',
      numSegments: this.WheelWedges.length,
      outerRadius: this.WheelDiameter / 2 - this.FrameWidth,
      centerX: this.WheelDiameter / 2,
      centerY: this.WheelDiameter / 2 + this.PointerOffset,
      segments: this.WheelWedges,
      drawMode: 'segmentImage',
      drawText: true,
      lineWidth: 3,
      animation: {
        type: 'spinOngoing',
        duration: 5,
        spins: 6,
        easing: 'Linear.easeNone',
        direction: 'anti-clockwise',
        repeat: -1,
        yoyo: false,
        callbackAfter: this.drawOverlay,
        callbackSound: this.playSegmentChange
      }
    });
    this.wheel.startAnimation();
  }

  stateStopping() {
    let stopAngle = this.computeStopAngle();

    this.wheel = new Winwheel({
      canvasId: 'wscoreWheelCanvas',
      numSegments: this.WheelWedges.length,
      outerRadius: this.WheelDiameter / 2 - this.FrameWidth,
      centerX: this.WheelDiameter / 2,
      centerY: this.WheelDiameter / 2 + this.PointerOffset,
      segments: this.WheelWedges,
      drawMode: 'segmentImage',
      drawText: true,
      lineWidth: 3,
      // Note animation properties passed in constructor parameters.
      animation: {
        type: 'spinToStop', // Type of animation.
        stopAngle: stopAngle, // Numeric value 0-360 of where the wheel is stop at after spinning.
        duration: 10, // How long the animation is to take in seconds.
        spins: 5, // The number of complete 360 degree rotations the wheel is to do.
        direction: 'anti-clockwise',
        easing: 'Power2.easeOut',
        callbackAfter: this.drawOverlay,
        callbackFinished: this.spindownFinished,
        callbackSound: this.playSegmentChange
      }
    });
    this.wheel.startAnimation();
  }

  stateResults() {
    this.props.playSpinEnd();
  }

  handleSpinClicked() {
    if (this.state.spinState === 'IDLE') this.setState({ spinState: 'SPINUP' });
  }

  spinupFinished() {
    if (this.props.stopIndex == null) {
      this.setState({ spinState: 'SPINNING' });
    } else {
      this.setState({ spinState: 'STOPPING' });
    }
  }

  spinResultReceived() {
    if (this.state.spinState === 'SPINNING') {
      this.setState({ spinState: 'STOPPING' });
    }
  }

  spindownFinished() {
    this.setState({ spinState: 'RESULTS' });
  }

  computeStopAngle() {
    let numSegments = this.WheelWedges.length;
    let anglePerSegment = 360 / numSegments;
    let edgeBuffer = anglePerSegment * 0.3; // 15% on each side of wedge deemed "liners" so don't land there
    let usableAnglePerSegment = anglePerSegment - edgeBuffer;

    let minStopAngle = this.props.stopIndex * anglePerSegment;

    let randomAngleIntoSegment = usableAnglePerSegment * Math.random();

    // angle of start of segment + half the edge buffer in case random is 0 + random
    return minStopAngle + edgeBuffer / 2 + randomAngleIntoSegment;
  }

  render() {
    return (
      <div className="winwheel" ref={this.props.refSetter}>
        <div className="win-wheel-background" />
        {this.canvas}
      </div>
    );
  }
}

export default withWheelSounds(WScoreWheel);
